export * from './RegionSettingsUI.interface';
export * from './RegionSettingsUI';

export { RegionSettingsUI as default } from './RegionSettingsUI';
